import { createAction } from 'redux-act'

import { NormalizedPointsHistory, PointsOverviewSectionOrders } from './types'

const fetchPointsHistoryStart = createAction('pointsHistory / fetch points history start')
const fetchPointsHistorySuccess = createAction<NormalizedPointsHistory>(
  'pointsHistory / fetch points history success',
)
const fetchPointsHistoryFail = createAction('pointsHistory / fetch points history fail')

const fetchOrderOfPointsStart = createAction('pointsHistory / fetch order of points start')
const fetchOrderOfPointsSuccess = createAction<PointsOverviewSectionOrders>(
  'pointsHistory / fetch order of points success',
)
const fetchOrderOfPointsFail = createAction('pointsHistory / fetch order of points fail')

export default {
  fetchPointsHistoryStart,
  fetchPointsHistorySuccess,
  fetchPointsHistoryFail,
  fetchOrderOfPointsStart,
  fetchOrderOfPointsSuccess,
  fetchOrderOfPointsFail,
}
